'use strict';

module.exports = function(type) {
	if (type === 'removeListeners') {
		window.removeEventListener('resize', this.setSizeAttributesNameSpace);
		return;
	}

	window.addEventListener('resize', this.setSizeAttributesNameSpace);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/granim/lib/onResize.js
// module id = 23
// module chunks = 0